
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router';
//services
import accountService from "@/core/services/AccountService"
//componentes
import DialogUser from "@/views/clubs/modals/AddEditUserModal.vue"
//libraries
import moment from 'moment';
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { errManager, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "clubs-users",
    components: { DialogUser },
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const { id } = route.params
        const loader = ref(false)
        const search = ref("")
        const listUsers = ref<any>([])
        const DialogUserRef = ref<any>(null)
        const itemUser = ref<any>(null)
        const setting = ref<any>({})

        const getSetting = async () => {
            await accountService.getOptions('api/accounts', 'setting')
                .then((res) => {
                    setting.value = res.data
                })
        }

        const getListUsers = async () => {
            loader.value = true
            await accountService.getData({
                id: id,
                "search": "",
                "instype": "A",
                "pageSize": 10,
                "currentPage": 1
            })
                .then((res) => {
                    loader.value = false
                    listUsers.value = res.data.list.map(user => ({ ...user, showPassword: false }));

                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        };

        const filteredList = computed(() => {
            return listUsers.value.filter((item) => {
                const searchTerm = search.value.toLowerCase();
                return (
                    item.username.toLowerCase().includes(searchTerm) || 
                    item.firstname.toLowerCase().includes(searchTerm) ||
                    item.lastname.toLowerCase().includes(searchTerm) || 
                    item.surname.toLowerCase().includes(searchTerm)
                    )
                });
        });

        const openModal = (data: any) => {
            if (DialogUserRef.value) {
                itemUser.value = data
                DialogUserRef.value.openModal();
            }
        };

        const onResponse = (data) => {
            if (!data) return;
            if (data.status == 'success') getListUsers()
        }

        // Función para alternar la visibilidad de la contraseña por ID
        const togglePassword = (user: any) => {
            user.showPassword = !user.showPassword;
        };

        const onDelete = (row: any) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: t('deleteText', {text: row?.firstname + ' ' + row?.lastname }),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                confirmButtonColor: "#d33",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                preConfirm: () => {
                    return accountService.delete(row.idaccount)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response.data}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification(result.value)
                    result.value.status === 'success' && getListUsers();
                }
            })
        };


        onMounted(() => {
            getSetting()
            getListUsers()
        })

        return {
            t,
            id,
            loader,
            search,
            itemUser,
            listUsers,
            setting,
            moment,
            filteredList,
            DialogUserRef,
            //events
            onResponse,
            getListUsers,
            openModal,
            togglePassword,
            onDelete
        }

    },
})
